import React, { useState } from 'react'
import { Form, Input, Button, Row, Col, message } from 'antd';
import { useMutation } from 'react-apollo';
import { RESET_PASSWORD } from '../../constants/graphql-query';
import { withRouter } from 'react-router-dom'
import { history } from '../../store';

const ResetPassword = (props) => {
    const [resetPasswordCallback, useData] = useMutation(RESET_PASSWORD);

    const [state, setState] = useState({
        confirmDirty: false
    })

    const { getFieldDecorator } = props.form;

    const handleSubmit = e => {
        e.preventDefault();

        props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            message.loading('Updating.. Please wait..', 0);
            resetPasswordCallback({
                variables: {
                    password: fieldsValue.newPassword,
                    confirmPassword: fieldsValue.confirmPassword,
                    accessToken: props.match.params.token
                }
            })
        });
    };

    if(useData && useData.data) {
        message.destroy();
        message.success(useData.data.resetPassword.msg);
        history.push('/login')
    }

    const config = (input, extRules = {}) => ({
        rules: [
            { required: true, message: `Please Enter ${input}` },
            extRules
        ],
    });

    const handleConfirmBlur = e => {
        const { value } = e.target;
        setState({ confirmDirty: state.confirmDirty || !!value });
    };

    const compareToFirstPassword = (rule, value, callback) => {
        const { form } = props;
        if (value && value !== form.getFieldValue('newPassword')) {
            callback('Two passwords that you enter is inconsistent!');
        } else {
            callback();
        }
    };

    const validateToNextPassword = (rule, value, callback) => {
        const { form } = props;
        if (value && state.confirmDirty) {
            form.validateFields(['confirmPassword'], { force: true });
        }
        callback();
    };

    return (
        <Row type="flex" align="middle" justify="center" gutter={[0, 8]} className="login-container">
            <Col span={6}>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col span={24}>
                            <h3><strong>Update Password</strong></h3>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="New Password:">
                                {getFieldDecorator(
                                    'newPassword',
                                    config(
                                        'New Password',
                                        {
                                            validator: validateToNextPassword
                                        }
                                    )
                                )(<Input type="text" />)}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Confirm Password:">
                                {getFieldDecorator(
                                    'confirmPassword',
                                    config(
                                        'Confirm Password',
                                        {
                                            validator: compareToFirstPassword
                                        }
                                    )
                                )(<Input type="password" onBlur={handleConfirmBlur} />)}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" block className="primary-dark">Reset Password</Button>
                            </Form.Item>

                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}

const ResetPasswordForm = Form.create({ name: 'updatepassword_form' })(ResetPassword);

export default withRouter(ResetPasswordForm);
